export const GOAL_CARD_TEXT = {
    twinLines: {
        name: '双线',
        description: '形成两条各含 3 子的直线，两条最多共用 1 格',
    },
    corner: {
        name: '占角',
        description: '完全占据四个角落 2×2 区域中的任意一个',
    },
    traverse: {
        name: '横贯',
        description: '棋子连通地从棋盘一侧连到对侧',
    },
    siege: {
        name: '围困',
        description: '让被指定的对手有一颗棋子八方被封死',
    },
    scatter: {
        name: '散布',
        description: '四个象限各至少 2 子，且没有任何 3 子共线',
    },
    island: {
        name: '孤岛',
        description: '至少 3 颗棋子，每颗的八方邻格都没有对手棋子',
    },
};
